<script>
export default {
  name: 'SideBar',
  render() {
    return (
      <aside class="SideBar">
        <el-row class="tac">
          <el-col class="menu">
            <el-menu
              default-active={ this.$route.meta.light || this.$route.path }
              class="el-menu-vertical-demo"
              router>
              { this.renderMenu(this.menuTree, this.$router.options.routes, 0) }
            </el-menu>
          </el-col>
        </el-row>
      </aside>
    );
  },
  data() {
    return {
    };
  },
  props: {
    menuTree: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    renderMenu(menuTree, optionRoutes, index) {
      return optionRoutes.map((item, routesIndex) => {
        if (item.name === 'Home') {
          return (
            <el-menu-item index={ item.path }>
              { item.meta.icon && <i class={ `el-icon-${item.meta.icon}` }></i> }
              <span>{ item.meta.title }</span>
            </el-menu-item>
          );
        }
        return menuTree.map((menuItem, menuIndex) => {
          if (menuItem.Code === item.name) {
            if (!item.children || item.meta.hideChildren) {
              return (
                <el-menu-item index={ item.path }>
                  { item.meta.icon && <i class={ `el-icon-${item.meta.icon}` }></i> }
                  <span>{ item.meta.title }</span>
                </el-menu-item>
              );
            }
            return (
              <el-submenu index={ `${index}-${routesIndex}` }>
                <template slot="title">
                  { item.meta.icon && <i class={ `el-icon-${item.meta.icon}` }></i> }
                  <span>{ item.meta.title }</span>
                </template>
                { this.renderMenu(menuItem.Children, item.children, routesIndex) }
              </el-submenu>
            );
          }
          return '';
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/SideBar.vue